import React from "react";
import CargoReportDetail from "../../../../components/cargo/CargoReportDetail";

export default function CargoReportTab({ flightId }) {
    // 航班监控入口沿用运营权限，完整字段可见；销售档案页自行传入 canDownload
    return <CargoReportDetail flightId={flightId} showSummary canDownload />;
}
